import styled, { breakpoints } from '../../../styles/theme';
import { TopNavbarStyled } from '../TopNavbarStyled';
import { rem } from 'polished';

export const TopNavbarStyledDS = styled(TopNavbarStyled)`
    background-color: ${({ theme }) => theme.colors.white};
    .Select {
        &__control {
            border: none;
        }

        &__indicators {
            padding: 4px;

            @media (min-width: ${breakpoints.sm}px) {
                padding: 5px;
            }

            @media (min-width: ${breakpoints.md}px) {
                padding: 8px;
            }
        }
    }
    .content {
        font-size: ${rem('22px')};

        &-title {
            color: ${({ theme }) => theme.colors.black1};
        }

        &-step {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};

            &::after {
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            }
        }
    }

    .topnavbar-returnlink {

        padding: ${rem(10)};
      
          @media (max-width: ${breakpoints.md}px) {
            border: unset;
            
            svg {
              height: ${rem('20px')};
              width: ${rem('20px')};
              
            }
          }
        &__text {
            display: none;

            @media (min-width: ${breakpoints.xs}px) {
                display: inline-block;
            }
        }

        color: ${({ theme }) => theme.colors.black1};
        border: 1px solid ${({ theme }) => theme.colors.grey6};
        :hover {
            background-color: ${({ theme }) => theme.colors.secondary};
            border-color: transparent;
        }
        svg {
            path {
                stroke: ${({ theme }) => theme.colors.black1};
            }
        }
    }
    &.dark {
        background-color: #454645;
        .content {
            .content-title {
                color: ${({ theme }) => theme.colors.white};
            }
        }
        .topnavbar-returnlink {
            color: ${({ theme }) => theme.colors.white};
            border: 1px solid ${({ theme }) => theme.colors.white};

            @media (max-width: ${breakpoints.xs}px) {
            width: fit-content;
            padding: 0;
            margin: 0 2px;
            }

            &:hover {
                background-color: ${({ theme }) => theme.colors.secondary};
                border-color: #454645;
            }
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.white};
                }
            }
        }
    }

    .icon-wrapper {
            height: auto;

            @media (max-width: ${breakpoints.xs}px) {
                width: fit-content;
                margin-right: ${rem('4px')};
            }

            @media (min-width: ${breakpoints.xs}px) {
                width: ${rem('13px')};
                margin-right: ${rem('4px')};
            }
            
        }

        svg {
            height: ${rem('36px')};
            width: ${rem('30px')};

            @media (min-width: ${breakpoints.xs}px) {
                height: ${rem('6px')};
                width: ${rem('13px')};
                margin: 0 0 ${rem('2px')} 0;
                path {
                    stroke: ${p => p.theme.colors.grey5};
                }
            }
        }
    }
`;
